export type ImageData = {
  url: string;
  alternateText: string;
};

export type ImageAttributes = {
  src: string;
  srcset: string;
  alternateText: string;
};

export type ImageSizes = {
  [key: string]: string;
};

export type ImageTypes = {
  carousel?: ImageSizes;
  card?: ImageSizes;
  hero?: ImageSizes;
  thumbnail?: ImageSizes;
  collage?: ImageSizes;
};

export function getImageSource(
  imageUrl: string,
  imageSize: number,
  imageSuffixes: ImageSizes,
): string {
  return `${imageUrl}${imageSuffixes[imageSize]}`;
}

export function getImageSourceSet(
  imageUrl: string,
  imageSuffixes: ImageSizes,
): string[] {
  return Object.entries(imageSuffixes).map(([screenWidth, imagePreset]) => {
    return `${imageUrl}${imagePreset} ${screenWidth}w`;
  });
}
